<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        class="woom-bike-outline woom-original-2"
        viewBox="0 0 800 600"
        style="enable-background: new 0 0 800 600"
        xml:space="preserve"
        v-once>
        <g class="bike">
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M393.8,433.2c2.2-4.4,3.5-9.9,3.5-16.5c0-32.9-34-36.4-34-36.4l-15.6,0.2l-128.1,5.8" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M191.2,387.6l-22.6,1c0,0-28.4,0.5-29.2,25.3c-0.9,24.4,14.3,29.3,29.5,30.4c15.1,1.1,177.3,10.3,188.1,9
				c3.5-0.4,12-1.2,20.3-5" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M408.6,464.5c-4.3,3.3-9.1,1.6-12.6-0.6" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M377.7,448.2l-27.2-23.6c0,0-6.9-9.1,1.7-18.3c0,0,10.6-8.9,19.1,0.4s37.4,44.4,37.4,44.4" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="381.3"
                y1="451.4"
                x2="377.7"
                y2="448.2" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M358,380.3l-23.4-58.2c0,0,15.4,0,23.4,0s20.4-2.3,39.6-13.5s131.4-75.9,131.4-75.9l1.4,3.4L375.1,382.9" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M395.6,405.1L541,266l1.6,4.6l31.1-11.9l-6.2-11.6l-15.1-37.4l-3.5-11.7l-30.5,12.2l1.3,3.6l-141.1,83.8
				c0,0-10.2,6.6-25.3,6c-15.1-0.7-26.2,0-26.2,0l-5-11.3l-16.5,6.7l-1.5,0.6l11.9,31.8c0,0-144.2,64.8-149.3,67.4
				c-5.1,2.6-4,8.2,1,8.4c5,0.1,8.1,2.9,8.6,6.3c0.5,3.4,0.4,2.5,0.5,5.8c0.1,3.2,1.6,3.6,4.7,3.6c3.1,0,137.7,1.1,137.7,1.1v-15.2
				l-125.6,1c0,0-13.3-7.4,0.1-12.6l127.1-54l14.6,36.7" />
            <polyline
                class="fill-none stroke-woom-black stroke-2"
                points="518.4,209.7 515,201.4 540.2,190.9 548.4,195.8 548.9,198" />
            <circle
                class="fill-none stroke-woom-black stroke-2"
                cx="361.6"
                cy="416.5"
                r="7" />
            <polyline
                class="fill-none stroke-woom-black stroke-2"
                points="555.6,295.3 553.1,294.9 543.2,271.8 573.6,259.5 582.4,282.9 581.8,284" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M562,274.7c9.7-3.6,14.7-0.3,16.3,2.6c1.6,3,51.3,114.1,51.3,114.1l-17.9,9.7l-31.6-57L552,287.2
				C552,287.2,550.6,278.9,562,274.7z" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M622,421.9c-1-1.9-8.5-17.3-8.5-17.3l-0.5-4.3l15.1-8l3.6,3.4c0,0,7.5,15.1,8,16.3c0.5,1.2,2,5,0.1,8.6
				c-1.8,3.6-2.7,1.1-3.6-0.9c-0.9-1.9-2.4-4.8-2.4-4.8s-1.3-3.2-5-1.7c-3.8,1.5-0.8,6.3-0.8,6.3l2.4,4.7c0,0,0.9,3.3-2.2,2
				C624.9,424.9,623.1,424,622,421.9z" />
            <rect
                x="371.7"
                y="451.8"
                class="fill-none stroke-woom-black stroke-2"
                width="61.3"
                height="12.2" />
            <polyline
                class="fill-none stroke-woom-black stroke-2"
                points="335.3,380 289.2,380 289.2,367.8 330.3,367.8" />
            <g>
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M253.1,372.1c2.1,4,3.9,8.2,5.4,12.5" />
                <g>
                    <path
                        class="fill-none stroke-woom-black stroke-2"
                        d="M257.5,449.1c-13.6,35.8-48.2,61.3-88.7,61.3c-52.4,0-94.8-42.5-94.8-94.8s42.5-94.8,94.8-94.8
						c32.6,0,61.4,16.5,78.5,41.6" />
                    <path
                        class="fill-none stroke-woom-black stroke-2"
                        d="M281.8,450.3c-14.8,48.3-59.8,83.4-113,83.4c-65.3,0-118.2-52.9-118.2-118.2s52.9-118.2,118.2-118.2
						c42.1,0,79.1,22,100,55.2" />
                </g>
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M274.6,362.9c3.3,6.5,5.9,13.4,7.9,20.5" />
            </g>
            <g>
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M600.3,325.9c9.7-3.3,20.1-5.1,30.9-5.1c52.4,0,94.8,42.5,94.8,94.8s-42.5,94.8-94.8,94.8
					s-94.8-42.5-94.8-94.8c0-32.2,16.1-60.7,40.6-77.8" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M590.8,304.5c12.6-4.6,26.2-7.1,40.4-7.1c65.3,0,118.2,52.9,118.2,118.2s-52.9,118.2-118.2,118.2
					S513,480.8,513,415.6c0-41.4,21.3-77.8,53.5-98.9" />
            </g>
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M466.4,330.6l-1.1,0.8c-0.2,0.2-0.5,0.2-0.8-0.1l-7.2-5.1c-2.4-1.7-5.4-2.1-8.2-0.1c-1.4,1-2.3,2.5-2.6,4.2
				c-1.9-0.2-3.7,0.5-4.9,1.3c-2.9,2.1-3.8,5-2.7,7.7c-2.9-1.4-6.4-1.1-9.1,0.8c-2.6,1.9-3.9,5-3.6,8c-2.8-1.2-6.1-0.9-8.8,1
				c-2.6,1.9-3.9,5-3.6,8l-1.3-1.8c-0.7-1-2-1.2-3-0.5c-1,0.7-1.2,2.1-0.5,3l5.4,7.5c0.8,1.1,0.3,2.7-0.7,3.5c-1,0.7-2.7,0.7-3.5-0.4
				l-0.1-0.1l-5.4-7.4c-0.7-1-2-1.2-3-0.5c-1,0.7-1.2,2.1-0.5,3l5.4,7.4l0.1,0.1c0.9,1.2,0.3,2.7-0.5,3.3c-0.9,0.6-1.9,0.8-3.2-0.2
				l-7.8-5.6c-1.9-1.3-3.7-0.6-4.4,0l-1.8,1.3c-1,0.7-1.2,2-0.5,2.9c0.7,1,2,1.1,3,0.4l1.1-0.8c0.2-0.2,0.5-0.2,0.8,0.1l7.2,5.1
				c2.4,1.7,5.4,2.1,8.2,0.1c1.4-1,2.3-2.5,2.6-4.2c1.9,0.2,3.7-0.5,4.9-1.3c2.8-2.1,3.8-5,2.7-7.7c2.9,1.4,6.4,1.1,9.1-0.8
				c2.6-1.9,3.9-5,3.6-8c2.8,1.2,6.1,0.9,8.8-1c2.6-1.9,3.9-5,3.6-8l1.3,1.8c0.7,1,2,1.2,3,0.5c1-0.7,1.2-2.1,0.5-3l-5.4-7.5
				c-0.8-1.1-0.3-2.7,0.7-3.5c1-0.7,2.7-0.7,3.5,0.4l0.1,0.1l5.4,7.4c0.7,1,2,1.2,3,0.5c1-0.7,1.2-2.1,0.5-3l-5.4-7.4l-0.1-0.1
				c-0.9-1.2-0.3-2.7,0.5-3.3c0.9-0.6,1.9-0.8,3.2,0.2l7.8,5.6c1.9,1.3,3.7,0.6,4.4,0l1.8-1.3c1-0.7,1.2-2,0.5-2.9
				C468.7,330,467.4,329.9,466.4,330.6z M425.5,360.2c-2.1,1.5-5,1-6.5-1.1s-1.1-5,1-6.5c2.1-1.5,5-1.1,6.6,1
				C428,355.8,427.6,358.7,425.5,360.2z M437.9,351.2c-2.1,1.5-5,1-6.5-1.1c-1.5-2.1-1.1-5,1-6.5c2.1-1.5,5-1.1,6.6,1
				S440,349.7,437.9,351.2z" />
        </g>
        <g class="saddle-normal">
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="282.7"
                y1="241"
                x2="305.6"
                y2="299" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M278.6,237.1l1.9,5l1.3-0.5c0,0,3.5-4.1,7.2-5.2c3.7-1.2,9-1.3,9-1.3l2-0.9l-1.5-4.6" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M287.4,234.1c0,0,16.3-9.1,27.2-12.3c10.9-3.2,32.6-6,35.8-6.5s7.3-0.7,7.4-3.2c0.1-2.5,0.4-9.8-5-13.3
				c-5.4-3.5-11.9-3.8-11.9-3.8s-20.8,1.2-26.4,1.5c-5.6,0.3-21.8-0.5-29.8-0.6c-8-0.1-43.8-0.9-49-1s-9.9,2.4-11,7.3
				s-2.3,13.3,0.3,15.1c2.5,1.9,8.7,6.2,18.8,9.6c10.1,3.4,21.3,8.9,27.8,9.8S282.8,236.5,287.4,234.1z" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="319.6"
                y1="292.9"
                x2="297.9"
                y2="235" />
        </g>
        <g class="handlebar-normal">
            <g>
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M525.1,71.1c1.1-0.4,2.4-0.5,3.6-0.5c6.7,0,12.2,5.5,12.2,12.2c0,6.7-5.5,12.2-12.2,12.2
					c-0.9,0-1.8-0.1-2.6-0.3" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M529.9,94.8c0,0,3,15.1,2.7,31.3s-0.1,44.4-0.1,44.4s1,9.1,9.2,8.5c8.2-0.6,9.4-7.3,9-11.2
					c-0.4-3.9-2.9-47.8-2.9-47.8s-1.4-20.8-3.6-28.4c-2.2-7.6-3.2-8.9-3.2-8.9" />
                <circle
                    class="fill-none stroke-woom-black stroke-2"
                    cx="512.9"
                    cy="83.4"
                    r="16.9" />
            </g>
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M550.2,161.7l1.6,1.4l1.1-1.2l3.6,0.5l0.7,4.2l-0.4,4l-1.2,7.1l-7.7,2c0,0-4.4,2.5-6.1,4.8s-1.6,6.4-1.6,6.4
				L515,201.4l-7-16.5l2.1-6.5l22.6-17.1" />
        </g>
        <g class="tyres hidden">
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="166.2"
                            y1="297.8"
                            x2="166.2"
                            y2="533.7" />
                        <g>
                            <rect
                                x="158.4"
                                y="296.6"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.4" />
                        </g>
                        <g>
                            <rect
                                x="158.4"
                                y="532.5"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.4" />
                        </g>
                    </g>
                </g>
            </g>
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="631.3"
                            y1="297.8"
                            x2="631.3"
                            y2="533.7" />
                        <g>
                            <rect
                                x="623.5"
                                y="296.6"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.4" />
                        </g>
                        <g>
                            <rect
                                x="623.5"
                                y="532.5"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.4" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g class="cockpit hidden">
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="513.2"
                            y1="83.4"
                            x2="513.2"
                            y2="533.3" />
                        <g>
                            <rect
                                x="505.4"
                                y="82.2"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.4" />
                        </g>
                        <g>
                            <rect
                                x="505.4"
                                y="532.1"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.4" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g class="steering-angle hidden">
            <g class="inline">
                <g>
                    <polyline
                        class="h-line fill-none stroke-woom-red stroke-3"
                        points="496.2,133.1 555.2,259.2 430.1,259.2" />
                </g>
                <path
                    class="h-line-miter fill-none stroke-woom-red stroke-3"
                    d="M506.2,258.9c0-19.5,11.6-36.4,28.2-44" />
            </g>
            <g class="inline">
                <g>
                    <g>
                        <g>
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="558.8"
                                y1="265.6"
                                x2="560.5"
                                y2="269.3" />
                            <line
                                class="h-dash-line fill-none stroke-woom-red stroke-3"
                                x1="563.8"
                                y1="276.3"
                                x2="681.4"
                                y2="526.6" />
                            <polyline
                                class="h-line fill-none stroke-woom-red stroke-3"
                                points="683.1,530.1 684.8,533.7 680.8,533.7" />
                            <line
                                class="h-dash-line fill-none stroke-woom-red stroke-3"
                                x1="673"
                                y1="533.7"
                                x2="567.6"
                                y2="533.7" />
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="563.7"
                                y1="533.7"
                                x2="559.7"
                                y2="533.7" />
                        </g>
                    </g>
                </g>
                <g>
                    <g>
                        <path
                            class="h-line fill-none stroke-woom-red stroke-3"
                            d="M635.2,533.9c0-1.3,0.1-2.7,0.2-4" />
                        <path
                            class="h-dash-line fill-none stroke-woom-red stroke-3"
                            d="M637.1,520.6c3.1-10.8,9.8-20.1,18.8-26.4" />
                        <path
                            class="h-line fill-none stroke-woom-red stroke-3"
                            d="M659.9,491.7c1.2-0.7,2.3-1.3,3.6-1.8" />
                    </g>
                </g>
            </g>
        </g>
        <g class="top-tube-horizontal hidden">
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="526.8"
                            y1="179.3"
                            x2="279"
                            y2="179.3" />
                        <g>
                            <rect
                                x="525.6"
                                y="171.5"
                                class="fill-woom-red stroke-woom-red"
                                width="2.4"
                                height="15.6" />
                        </g>
                        <g>
                            <rect
                                x="277.8"
                                y="171.5"
                                class="fill-woom-red stroke-woom-red"
                                width="2.4"
                                height="15.6" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g class="wheelbase hidden">
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="629.6"
                            y1="416.3"
                            x2="168.2"
                            y2="416.3" />
                        <g>
                            <rect
                                x="628.4"
                                y="408.5"
                                class="fill-woom-red stroke-woom-red"
                                width="2.4"
                                height="15.6" />
                        </g>
                        <g>
                            <rect
                                x="167"
                                y="408.5"
                                class="fill-woom-red stroke-woom-red"
                                width="2.4"
                                height="15.6" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g class="seat-tube-angle hidden">
            <g class="inline">
                <polyline
                    class="h-line fill-none stroke-woom-red stroke-3"
                    points="313.3,296.6 408.3,533.7 177.2,533.7" />
            </g>
            <path
                class="h-line-miter inline fill-none stroke-woom-red stroke-3"
                d="M361.5,533.8c0-19.5,11.6-36.4,28.2-44" />
        </g>
        <g class="min-saddle-height hidden">
            <g class="inline">
                <g>
                    <g>
                        <g>
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="294.1"
                                y1="226.8"
                                x2="290"
                                y2="226.8" />
                            <line
                                class="h-dash-line fill-none stroke-woom-red stroke-3"
                                x1="281.6"
                                y1="226.8"
                                x2="34.6"
                                y2="226.8" />
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="30.4"
                                y1="226.8"
                                x2="26.2"
                                y2="226.8" />
                        </g>
                    </g>
                </g>
                <g>
                    <g>
                        <g>
                            <g>
                                <line
                                    class="h-line fill-none stroke-woom-red stroke-3"
                                    x1="13.1"
                                    y1="226.8"
                                    x2="13.1"
                                    y2="533.2" />
                                <g>
                                    <rect
                                        x="5.3"
                                        y="225.6"
                                        class="fill-woom-red stroke-woom-red"
                                        width="15.6"
                                        height="2.4" />
                                </g>
                                <g>
                                    <rect
                                        x="5.3"
                                        y="532"
                                        class="fill-woom-red stroke-woom-red"
                                        width="15.6"
                                        height="2.4" />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
            <g class="inline">
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="295.2"
                    y1="272.9"
                    x2="305.2"
                    y2="297.9" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M291.2,269l1.9,5l1.3-0.5c0,0,3.5-4.1,7.2-5.2s9-1.3,9-1.3l2-0.9l-1.5-4.6" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M300,266c0,0,16.3-9.1,27.2-12.3s32.6-6,35.8-6.5c3.3-0.5,7.3-0.7,7.4-3.2s0.4-9.8-5-13.3
					c-5.4-3.5-11.9-3.8-11.9-3.8s-20.8,1.2-26.4,1.5s-21.8-0.5-29.8-0.6c-8-0.1-43.8-0.9-49-1s-9.9,2.4-11,7.3s-2.3,13.3,0.3,15.1
					c2.5,1.9,8.7,6.2,18.8,9.6c10.1,3.4,21.3,8.9,27.8,9.8C290.8,269.5,295.4,268.4,300,266z" />
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="319.6"
                    y1="292.9"
                    x2="309.5"
                    y2="266.9" />
            </g>
        </g>
        <g class="max-saddle-height hidden">
            <g class="inline">
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="273.2"
                    y1="215.9"
                    x2="305.2"
                    y2="297.9" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M269.2,212l1.9,5l1.3-0.5c0,0,3.5-4.1,7.2-5.2s9-1.3,9-1.3l2-0.9l-1.5-4.6" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M278,209c0,0,16.3-9.1,27.2-12.3c10.9-3.2,32.6-6,35.8-6.5c3.3-0.5,7.3-0.7,7.4-3.2s0.4-9.8-5-13.3
					c-5.4-3.5-11.9-3.8-11.9-3.8s-20.8,1.2-26.4,1.5s-21.8-0.5-29.8-0.6c-8-0.1-43.8-0.9-49-1s-9.9,2.4-11,7.3s-2.3,13.3,0.3,15.1
					c2.5,1.9,8.7,6.2,18.8,9.6c10.1,3.4,21.3,8.9,27.8,9.8C268.8,212.5,273.4,211.4,278,209z" />
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="319.6"
                    y1="292.9"
                    x2="287.5"
                    y2="209.9" />
            </g>
            <g class="inline">
                <g>
                    <g>
                        <g>
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="278.6"
                                y1="169.8"
                                x2="274.2"
                                y2="169.8" />
                            <line
                                class="h-dash-line fill-none stroke-woom-red stroke-3"
                                x1="265.2"
                                y1="169.8"
                                x2="36.6"
                                y2="169.8" />
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="32.1"
                                y1="169.8"
                                x2="27.7"
                                y2="169.8" />
                        </g>
                    </g>
                </g>
                <g>
                    <g>
                        <g>
                            <g>
                                <line
                                    class="h-line fill-none stroke-woom-red stroke-3"
                                    x1="13.1"
                                    y1="169.8"
                                    x2="13.1"
                                    y2="533.1" />
                                <g>
                                    <rect
                                        x="5.3"
                                        y="168.6"
                                        class="fill-woom-red stroke-woom-red"
                                        width="15.6"
                                        height="2.4" />
                                </g>
                                <g>
                                    <rect
                                        x="5.3"
                                        y="531.9"
                                        class="fill-woom-red stroke-woom-red"
                                        width="15.6"
                                        height="2.4" />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g class="crank-length hidden">
            <g class="inline">
                <line
                    class="h-line-miter fill-none stroke-woom-red stroke-3"
                    x1="360.8"
                    y1="415.6"
                    x2="403.2"
                    y2="459" />
                <g>
                    <rect
                        x="353"
                        y="414.4"
                        transform="matrix(0.7154 -0.6987 0.6987 0.7154 -187.6793 370.3316)"
                        class="fill-woom-red stroke-woom-red"
                        width="15.6"
                        height="2.4" />
                </g>
                <g>
                    <rect
                        x="395.4"
                        y="457.8"
                        transform="matrix(0.7154 -0.6987 0.6987 0.7154 -205.9675 412.3559)"
                        class="fill-woom-red stroke-woom-red"
                        width="15.6"
                        height="2.4" />
                </g>
            </g>
        </g>
        <g class="handlebar-adjustability hidden">
            <g class="inline">
                <g>
                    <g>
                        <g>
                            <g>
                                <path
                                    class="h-line fill-none stroke-woom-red stroke-3"
                                    d="M534,25.1c23.4,2.1,42,20.7,44.1,44.1" />
                                <g>
                                    <polygon
                                        class="fill-woom-red stroke-woom-red"
                                        points="535.2,31.2 525.4,24.4 536.3,19.3" />
                                </g>
                                <g>
                                    <polygon
                                        class="fill-woom-red stroke-woom-red"
                                        points="572,68 578.9,77.8 583.9,66.9" />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
            <g class="inline">
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M481.5,89.1c0.8-0.8,1.8-1.6,3-2.2c6-3.1,13.3-0.8,16.4,5.2s0.8,13.3-5.2,16.4c-0.8,0.4-1.6,0.7-2.5,1" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M496.8,107.9c0,0,9.6,12.1,16.9,26.5c7.3,14.4,20.4,39.4,20.4,39.4s5.1,7.6,12.1,3.3c7-4.3,4.9-10.8,2.8-14.1
					c-2.1-3.3-24.7-41.1-24.7-41.1s-10.9-17.8-16.4-23.5c-5.5-5.7-7-6.4-7-6.4" />
                <circle
                    class="fill-none stroke-woom-black stroke-2"
                    cx="476.4"
                    cy="105.6"
                    r="16.9" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M546.7,159.4l5.1,3.7l1.1-1.2l3.6,0.5l0.7,4.2l-0.4,4l-1.2,7.1l-7.7,2c0,0-4.4,2.5-6.1,4.8s-1.6,6.4-1.6,6.4
					L515,201.4l-7-16.5l2.1-6.5l18.9-14.3" />
            </g>
        </g>
        <g class="stand-over-height hidden">
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="13.1"
                            y1="277.4"
                            x2="13.1"
                            y2="533.3" />
                        <g>
                            <rect
                                x="5.3"
                                y="276.2"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.4" />
                        </g>
                        <g>
                            <rect
                                x="5.3"
                                y="532.1"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.4" />
                        </g>
                    </g>
                </g>
            </g>
            <g class="inline">
                <g>
                    <g>
                        <g>
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="408.6"
                                y1="277.3"
                                x2="404.2"
                                y2="277.3" />
                            <line
                                class="h-dash-line fill-none stroke-woom-red stroke-3"
                                x1="395.5"
                                y1="277.3"
                                x2="34.7"
                                y2="277.3" />
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="30.4"
                                y1="277.3"
                                x2="26"
                                y2="277.3" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>
